import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { ServiceDeleteBase } from "../../../shared/services/base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { TecnicoService } from "./TecnicoService";

/** Baja de técnicos; la saca del listado en memoria. */
export class TecnicoDeleteService extends ServiceDeleteBase {
  protected readonly cache = TecnicoService.instance;

  /** gRPC-Web (`EliminarTecnico`): baja lógica del técnico y de su usuario, con cierre de sesiones. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(ProyectosPlataformaService).eliminarTecnico({ id }));
  }
}
